import { forwardRef } from "react";
import { IMaskInput } from 'react-imask';

const PhoneMaskCustom = forwardRef(function PhoneMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
        <IMaskInput
            {...other}
            mask={'(00) 0 0000-0000'}
            definitions={{
                '0': /[0-9]/
            }}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

export default PhoneMaskCustom;

